export const UPDATE_DATA = '@application/update-data';
export const UPDATE_STORE = '@application/update-store';
export const UPDATE_STEP = '@application/update-step';
export const UPDATE_STAGE = '@application/update-stage';

export function updateData(section, data) {
  return (dispatch) => dispatch({
    type: UPDATE_DATA,
    payload: {
      section,
      data,
    },
  });
}

export function updateStage(stage) {
  return (dispatch) => dispatch({
    type: UPDATE_STAGE,
    payload: {
      stage,
    },
  });
}

export function updateStore(item, data) {
  return (dispatch) => dispatch({
    type: UPDATE_STORE,
    payload: {
      item,
      data,
    },
  });
}

export function updateStep(name, number) {
  return (dispatch) => dispatch({
    type: UPDATE_STEP,
    payload: {
      name,
      number,
    }
  });
}
